import { render, staticRenderFns } from "./DataMixup.vue?vue&type=template&id=0e3bd286&scoped=true"
import script from "./DataMixup.vue?vue&type=script&lang=js"
export * from "./DataMixup.vue?vue&type=script&lang=js"
import style0 from "./DataMixup.vue?vue&type=style&index=0&id=0e3bd286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bd286",
  null
  
)

export default component.exports